import { useState } from 'react'
import { FileVideo2 } from 'lucide-react'
// import { useSnapshot } from 'valtio'
import { Upload } from 'antd'

import useInputUpload from '@/hooks/useInputUpload'
import ActionIcon from './ActionIcon'
const Icon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 6.9989L13 9.9989L9 12.9989V6.9989Z"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4165 1.7489C16.4165 1.33469 16.0807 0.998901 15.6665 0.998901C15.2523 0.998901 14.9165 1.33469 14.9165 1.7489V2.66565H14C13.5858 2.66565 13.25 3.00144 13.25 3.41565C13.25 3.82986 13.5858 4.16565 14 4.16565H14.9165V5.08223C14.9165 5.49645 15.2523 5.83223 15.6665 5.83223C16.0807 5.83223 16.4165 5.49645 16.4165 5.08223V4.16565H17.3333C17.7475 4.16565 18.0833 3.82986 18.0833 3.41565C18.0833 3.00144 17.7475 2.66565 17.3333 2.66565H16.4165V1.7489Z"
      fill="#0077FA"
    />
    <path
      d="M17.542 7.32426C17.8386 8.16059 18 9.06089 18 9.9989C18 14.4172 14.4183 17.9989 10 17.9989C5.58172 17.9989 2 14.4172 2 9.9989C2 5.58062 5.58172 1.9989 10 1.9989C10.5787 1.9989 11.143 2.06034 11.6868 2.17705"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const AudioUpload = () => {
  const { uploadLoading, beforeUploadVideo } = useInputUpload()

  return (
    <Upload
      accept="video/*"
      beforeUpload={beforeUploadVideo}
      maxCount={1}
      showUploadList={false}
    >
      <ActionIcon
        title="支持mp4、avi等视频格式，一次最多上传一个文件，大小不超过50M，视频时长不超过1分钟。"
        Icon={Icon}
        loading={uploadLoading}
      />
    </Upload>
  )
}

export default AudioUpload
